import Offcanvas from '@partials/UI/offcanvas/modules/Offcanvas';

new Offcanvas ({
	selector: '#mobile-menu',
   close: '#mobile-menu .close_el',
   open: '.burger',
   overlay: '.ov_offcanvas'
})